import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import InputDisplayTemplate from '../../components/InputDisplayTemplate'

const PwdInformation = ({ pwdInfo }) => {
  return (
    <>
      <div className="row d-flex  mb-1 p-3" style={{height:'500px', overflowY:'scroll', }}>
        <h3 className="cms-text-primary font-weight-bold py-2">PWD Assistance Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Monetary Allowance" dataItem={_.get(pwdInfo, 'attributes.has_monetary_allowance') ? 'Yes' : 'No' || '- -'} />
          <InputDisplayTemplate title="Assisted Device" dataItem={_.get(pwdInfo, 'attributes.has_assisted_device') ? 'Yes' : 'No' || '- -'} />
          <InputDisplayTemplate title="Donor" dataItem={(_.get(pwdInfo, 'attributes.device_donor'))  || '- -'} />
          <InputDisplayTemplate title="Type of Disablity" dataItem={_.get(pwdInfo, 'attributes.disability_name') || '- -'} />
        </div>

        <h3 className="cms-text-primary font-weight-bold py-2">Personal Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(pwdInfo, 'attributes.last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(pwdInfo, 'attributes.first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(pwdInfo, 'attributes.middle_name'))  || '- -'} />
          <InputDisplayTemplate title="Suffix" dataItem={_.get(pwdInfo, 'attributes.extension_name') || '- -'} />
          <InputDisplayTemplate title="Gender" dataItem={_.get(pwdInfo, 'attributes.gender') || '- -'} />
          <InputDisplayTemplate title="Date of Birth" dataItem={_.get(pwdInfo, 'attributes.birth_date') || '- -'} />
          <InputDisplayTemplate title="Age" dataItem={(_.get(pwdInfo, 'attributes.age'))  || '- -'} />
        </div>
        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Contact Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Email Address" dataItem={(_.get(pwdInfo, 'attributes.email'))  || '- -'} />
          <InputDisplayTemplate title="Mobile Number" dataItem={(_.get(pwdInfo, 'attributes.mobile_number')) || '- -'} />
          <InputDisplayTemplate title="Telephone Number" dataItem={_.get(pwdInfo, 'attributes.telephone_number') || '- -'} />
        </div>
        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Address</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Region" dataItem={_.get(pwdInfo, 'attributes.region_name') || '- -'} />
          <InputDisplayTemplate title="Province" dataItem={_.get(pwdInfo, 'attributes.province_name') || '- -'} />
          <InputDisplayTemplate title="Municipality" dataItem={_.get(pwdInfo, 'attributes.municipality_name') || '- -'} />
          <InputDisplayTemplate title="Barangay" dataItem={_.get(pwdInfo, 'attributes.barangay_name') || '- -'} />
          <InputDisplayTemplate title="Zone" dataItem={_.get(pwdInfo, 'attributes.zone') || '- -'} />
          <InputDisplayTemplate title="Unit No. / House No. / Street Name" dataItem={_.get(pwdInfo, 'attributes.address') || '- -'} />
        </div>
        
        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Place of Birth</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Region" dataItem={_.get(pwdInfo, 'attributes.place_of_birth_region_name') || '- -'} />
          <InputDisplayTemplate title="Province" dataItem={_.get(pwdInfo, 'attributes.place_of_birth_province_name') || '- -'} />
          <InputDisplayTemplate title="Municipality" dataItem={_.get(pwdInfo, 'attributes.place_of_birth_municipality_name') || '- -'} />
          <InputDisplayTemplate title="Date of Birth" dataItem={_.get(pwdInfo, 'attributes.birth_date') || '- -'} />
        </div>
        <h2 className="col-12 cms-text-primary font-weight-bold pb-2 pt-3">Family Information</h2>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Mothers Maiden Name</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(pwdInfo, 'attributes.mother_maiden_last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(pwdInfo, 'attributes.mother_maiden_first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(pwdInfo, 'attributes.mother_maiden_middle_name')) || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Fathers Name</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(pwdInfo, 'attributes.father_last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(pwdInfo, 'attributes.father_first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(pwdInfo, 'attributes.father_middle_name'))  || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Spouse Name</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Last Name" dataItem={_.get(pwdInfo, 'attributes.spouse_last_name') || '- -'} />
          <InputDisplayTemplate title="First Name" dataItem={_.get(pwdInfo, 'attributes.spouse_first_name') || '- -'} />
          <InputDisplayTemplate title="Middle Name" dataItem={(_.get(pwdInfo, 'attributes.spouse_middle_name'))  || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Identity Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Height" dataItem={_.get(pwdInfo, 'attributes.height') || '- -'} />
          <InputDisplayTemplate title="Weight" dataItem={_.get(pwdInfo, 'attributes.weight') || '- -'} />
          <InputDisplayTemplate title="Complexion" dataItem={(_.get(pwdInfo, 'attributes.complexion'))  || '- -'} />
          <InputDisplayTemplate title="Country of Citizenship" dataItem={(_.get(pwdInfo, 'attributes.citizenship_code'))  || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Educational Information</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Highest Educational Attainment" dataItem={_.get(pwdInfo, 'attributes.educational_attainment') || '- -'} />
          <InputDisplayTemplate title="Institution" dataItem={_.get(pwdInfo, 'attributes.institution_name') || '- -'} />
        </div>

        <h3 className="col-12 cms-text-primary font-weight-bold py-2">Valid ID</h3>
        <div className="col-12 mb-3 p-1 form-wrapper-alternate-bg">
          <InputDisplayTemplate title="Type of Valid ID" dataItem={_.get(pwdInfo, 'attributes.id_type') || '- -'} />
          <InputDisplayTemplate title="Valid ID" dataItem={_.get(pwdInfo, 'attributes.id_url') || '- -'} isImage />
        </div>
      </div>
    </>
  );
};

PwdInformation.propTypes = {
  pwdInfo: PropTypes.instanceOf(Object).isRequired,
};

export default PwdInformation;
